import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

import { mapStylesUpdateVehicleFeatures } from './utils/mapStylesUpdateVehicleFeatures'

export const createUpdateVehicleFeaturesMapStyleFromChangelog = (
  markers: uui.domain.ui.map.markers.MapMarkers['vehicle'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['vehicle'],
  selection: Set<string>,
) => {
  // ATTENTION: Application of Map Style changes will not be cached if a delayed rendering mechanism will be implemented
  // After the whole set of delayed marker changelogs is applied a full refresh of Map Styles will be required

  return async () => {
    const map = mapAtom.map
    const layer = findLayer(map, 'vehicle')

    // only the `update` field is populated in a mapStyles changelog
    await mapStylesUpdateVehicleFeatures(layer, markers, mapStyles, selection)
  }
}
